// src/lib/scheduler.js
// src/lib/scheduler.js
export function nextBusinessSlot(base = new Date(), stepMin = 15) {
  const d = new Date(base);
  // round up to step
  const step = stepMin * 60 * 1000;
  d.setTime(Math.ceil(d.getTime() / step) * step);

  const h = d.getHours();
  if (h >= 17) {
    d.setDate(d.getDate() + 1);
    d.setHours(9, 0, 0, 0);
  } else if (h < 9) {
    d.setHours(9, 0, 0, 0);
  } else {
    d.setMinutes(Math.ceil(d.getMinutes() / stepMin) * stepMin, 0, 0);
  }

  while ([0, 6].includes(d.getDay())) {
    d.setDate(d.getDate() + 1);
    d.setHours(9, 0, 0, 0);
  }
  return d;
}

export function suggestHuddleSlotFromDecisions(dec) {
  const now = new Date();
  if (dec?.mission_critical?.length) return nextBusinessSlot(now);
  if (dec?.this_week?.length) {
    const d = new Date(now);
    d.setDate(d.getDate() + 1);
    d.setHours(10, 0, 0, 0);
    while ([0, 6].includes(d.getDay())) d.setDate(d.getDate() + 1);
    return d;
  }
  const d = new Date(now);
  const day = d.getDay();
  const daysToMon = (8 - day) % 7 || 7;
  d.setDate(d.getDate() + daysToMon);
  d.setHours(10, 0, 0, 0);
  return d;
}
export default nextBusinessSlot;
